import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { useData } from '../context/DataContext';
import logoImage from '../assets/lojeperf.png';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  const { categories } = useData();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleCategoryDropdown = () => {
    setCategoryDropdownOpen(!categoryDropdownOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setCategoryDropdownOpen(false);
  };

  return (
    <>
      <header className="header">
        <div className="container">
          <div className="header-content">
            <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
            
            <Link to="/" className="logo" onClick={closeMobileMenu}>
              <img src={logoImage} alt="LOJE" className="logo-image" />
            </Link>
            
            <nav className={`nav ${mobileMenuOpen ? 'active' : ''}`}>
              <Link to="/" onClick={closeMobileMenu}>Home</Link>
              
              <div className={`category-dropdown ${categoryDropdownOpen ? 'active' : ''}`}>
                <div 
                  className="category-dropdown-trigger" 
                  onClick={toggleCategoryDropdown}
                >
                  Categories <ChevronDown size={16} />
                </div>
                <div className="category-dropdown-menu">
                  {categories.map(category => (
                    <Link 
                      key={category.docId} 
                      to={`/category/${category.id}`}
                      onClick={closeMobileMenu}
                    >
                      {category.name}
                    </Link>
                  ))}
                </div>
              </div>
              
              <Link to="/shop-all" onClick={closeMobileMenu}>Shop All</Link>
              <Link to="/about" onClick={closeMobileMenu}>About</Link>
              <Link to="/contact" onClick={closeMobileMenu}>Contact</Link>
            </nav>
          </div>
        </div>
      </header>
      <div 
        className={`mobile-overlay ${mobileMenuOpen ? 'active' : ''}`}
        onClick={closeMobileMenu}
      />
    </>
  );
};

export default Header;
